import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import type { BuildingPrimaryPropertyType } from '@quipex/shared/contracts';
import { Skeleton } from '@quipex/shared/ui';
import { getBuildingSceneryImage } from '../building-scenery';

@Component({
    selector: 'qpx-building-scenery',
    imports: [NgOptimizedImage, Skeleton],
    templateUrl: './building-scenery-image.html',
    styleUrl: './building-scenery-image.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'aria-hidden': 'true',
    },
})
export class QpxBuildingScenery {
    public readonly propertyType = input<
        BuildingPrimaryPropertyType | undefined
    >();
    public readonly priority = input(true);

    protected readonly image = computed(() => {
        const propertyType = this.propertyType();
        return propertyType === undefined
            ? null
            : getBuildingSceneryImage(propertyType);
    });
}
